<script setup lang="ts">
useHead({
  script: [
    {
      src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
      async: true
    }
  ]
});
</script>

<template>
  <div class="trustpilot-widget" data-locale="de-DE" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="61827147750b1c0ce95c4625" data-style-height="24px" data-style-width="100%">
    <a href="https://de.trustpilot.com/review/tauschwohnung.com" target="_blank" rel="noopener">Trustpilot</a>
  </div>
</template>
